module.exports = __webpack_public_path__ + "static/img/h1-2.fbdcba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h1-2.png
// module id = QbzI
// module chunks = 1